import IconUser from "images/icon-user.svg";
import IconUserActive from "images/icon-user-active.svg";
import { useClickOutside } from "@mantine/hooks";

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import api from "services/api";
import { useCurrentUserQuery, useFunctionsQuery } from "services/api";
import { logout, setUserInfo } from "features/backstage/auth/authSlice";

import { useAppDispatch } from "App/store";
import { FUNCTIONS_URL } from "App/routes";

const Avatar = () => {
  const { data: currUser } = useCurrentUserQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const { data: currUserFunctions = [] } = useFunctionsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: !currUser,
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setUserInfo(currUser));
  }, [currUser, dispatch]);

  const [opened, setOpened] = useState(false);

  const ref = useClickOutside(() => setOpened(false));

  const navigate = useNavigate();

  return currUser ? (
    <>
      <button
        className="hidden h-[38px] w-[38px] bg-transparent md:block lg:h-15  lg:w-20"
        onClick={() => setOpened(!opened)}
      >
        <img
          className="h-full"
          src={IconUserActive}
          alt="已登入"
          draggable="false"
        />
      </button>
      {opened && (
        <div
          ref={ref}
          className="absolute right-0 -mt-3 -mr-1  min-w-[192px] rounded-xl bg-white px-4 py-2 text-xs leading-7 shadow-sm"
        >
          <p className="text-black">{currUser.email || currUser.empName}</p>

          <ul>
            {currUserFunctions?.map((x) => (
              <li key={x.funNo}>
                <Link
                  to={`${FUNCTIONS_URL}/${x.url}`}
                  className="block w-full text-sm text-gray-500"
                >
                  {x.funName}
                </Link>
              </li>
            ))}
          </ul>

          <p>
            <button
              className="w-full bg-transparent text-left text-gray-500"
              onClick={() => {
                dispatch(logout());
                dispatch(api.util.resetApiState());

                navigate("/");
              }}
            >
              登出
            </button>
          </p>
        </div>
      )}
    </>
  ) : (
    <Link to="/login" className="hidden w-[38px] md:block lg:h-15 lg:w-20">
      <img className="h-full" src={IconUser} alt="登入" draggable="false" />
    </Link>
  );
};

export default Avatar;
